import Cookies from "js-cookie";
import MicroModal from 'micromodal';
import ouibounce from 'ouibounce';

/**
 * Open subscribe modal before user leave the website
 *
 * NOTE: We are no longer using MicroModal to open the announcement modal
 *  HTML dialog element has built-in show() and close() methods
 */

export default {
    initAnnouncementModal () {
        const announcementModal = document.getElementById('modal-announcement');

        if (!announcementModal) {
            return;
        }

        const site = announcementModal.dataset.site ?? 'default';
        const actionButtons = Array.from(announcementModal.querySelectorAll('[data-action]') ?? []);

        // Use sessionStorage to check if the user has already interacted with the announcement modal
        const announcementKey = `headland_${site}_announcementModalShown`;
        const announcementShown = sessionStorage.getItem(announcementKey);

        if (announcementShown && announcementShown === 'true') {
            return;
        }

        announcementModal.show();
        document.body.classList.toggle('disable-scroll', true);

        actionButtons.forEach(button => {
            button.addEventListener('click', () => {
                sessionStorage.setItem(announcementKey, 'true');

                if (button.dataset.action === 'close') {
                    announcementModal.close();
                    document.body.classList.toggle('disable-scroll', false);
                }
            });
        });
    },
    initSubscribeModal() {
        console.log('Modals module loaded');
        const subscribeModal = document.getElementById('modal-subscribe');

        if (subscribeModal) {
            ouibounce(false, {
                sitewide: true,
                delay: 100,
                callback: () => MicroModal.show(subscribeModal.id)
            })
        }
    },
    init() {
        document.addEventListener('DOMContentLoaded', () => {
            // this.initSubscribeModal();
            this.initAnnouncementModal();
        });
    },
}
